import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import TeamScore from "../components/TeamScore";

const ScoreBoardPage: React.FC = () => {
  const matchPoint: number = 25;
  const [team1Score, setTeam1Score] = useState(0);
  const [team2Score, setTeam2Score] = useState(0);

  const incremenetTeamScore = (teamId: number) => {
    if (team1Score === matchPoint || team2Score === matchPoint) {
      return;
    } else {
      teamId === 1
        ? setTeam1Score((score) => score + 1)
        : setTeam2Score((score) => score + 1);
    }
  };

  return (
    <div className="App">
      <Helmet>
        <title>Score Board 🏐</title>
      </Helmet>
      <div className="App-header">
        <div className="team-score-container w-100 px-5 py-5">
          <TeamScore
            teamId={1}
            teamColor={"blue"}
            score={team1Score}
            opponentScore={team2Score}
            matchPoint={matchPoint}
            incrementScoreAction={incremenetTeamScore}
          />
          <TeamScore
            teamId={2}
            teamColor={"orange"}
            score={team2Score}
            opponentScore={team1Score}
            matchPoint={matchPoint}
            incrementScoreAction={incremenetTeamScore}
          />
        </div>
      </div>
    </div>
  );
};

export default ScoreBoardPage;
